import { ActionEnum } from '@Policy/utils/types';

export const actionTranslateMap = {
  [ActionEnum.passWithoutLogging]: 'policy.action.passWithoutLogging',
  [ActionEnum.sanitizeFile]: 'policy.action.sanitizeFile',
  [ActionEnum.tagSubject]: 'policy.action.tagSubject',
  [ActionEnum.pass]: 'policy.action.pass',
  [ActionEnum.replaceWithTextFile]: 'policy.action.replace',
  [ActionEnum.delete]: 'policy.action.delete',
  [ActionEnum.quarantine]: 'policy.action.quarantine',
  [ActionEnum.passwordQuarantine]: 'policy.action.passwordQuarantine',
  [ActionEnum.removeLink]: 'policy.action.removeLink',
  [ActionEnum.moveToJunkEmailFolder]: 'policy.action.moveToJunk',
  [ActionEnum.addDisclaimer]: 'policy.action.addDisclaimer',
  [ActionEnum.labelEmail]: 'policy.action.labelEmail',
  [ActionEnum.moveToSpam]: 'policy.action.moveToSpam',
  [ActionEnum.block]: 'policy.action.block',
  [ActionEnum.applySensitivityLabel]: 'policy.action.applySensitivityLabel',
  [ActionEnum.removeSensitivityLabel]: 'policy.action.removeSensitivityLabel',
  [ActionEnum.changeRecipient]: 'policy.action.changeRecipient',
  [ActionEnum.tagFileName]: 'policy.action.tagFilename',
};
